import React, { useState, useEffect } from "react";
import { Row } from 'reactstrap';
import { ScoreCard } from "../components/ScoreCard";

import questions from "../questions";
import Log from "../Log";

const State = {
    Error: "Error",
    OK: "OK",
    Warning: "Warning"
};

const ResultsContainer = props => {
    const [results, setResults] = useState([]);
    const [header, setHeader] = useState("header");

    useEffect(() => {
        const errors = getAnswers({
            answers: props.answers,
            state: State.Error
        });
        if (errors.length > 0) {
            const warnings = getAnswers({
                answers: props.answers,
                state: State.Warning
            });
            setResults([...errors], [...warnings]);
            setHeader(getHeader({
                state: State.Error
            }));
        }
        else {
            const warnings = getAnswers({
                answers: props.answers,
                state: State.Warning
            });
            if (warnings.length > 0) {
                setResults([...warnings]);
                setHeader(getHeader({
                    state: State.Warning
                }));
            }
            else {
                const ok = getAnswers({
                    answers: props.answers,
                    state: State.OK
                });
                setResults([...ok]);
                setHeader(getHeader({
                    state: State.OK
                }));
            }
        }
    }, [props]);

    const getHeader = ({ state }) => {
        switch (state) {
            case State.Error:
                return (
                    <Row>
                        <h1>Not Eligible</h1>
                        <p className="lead">
                        We are sorry. We cannot process your request at this time.
                        </p>
                    </Row>
                );
            case State.Warning:
                return (
                    <Row>
                        <h1>Attention</h1>
                        <p className="lead">
                        You now need to visit a branch to verify yourself and your right to make this request on behalf of the Consumer.  Please bring two forms of valid identification (Driver’s License, Passport, etc.), as well as documentation showing your legal right to act on behalf of the Consumer.  The request will not be processed until this step is complete.  Your request will be processed promptly after the verification is complete.
                        </p>
                    </Row>
                );
            case State.OK:
                return (
                    <Row>
                        <h1>
                        Thank You for Your Request.
                        </h1>
                        <p className="lead">
                        Your request will be processed promptly. Responses to requests will be delivered at the email address or mailing address on file. For any questions, please call our Data Rights line at (855) 210-9448.
                        </p>
                    </Row>
                );
            default:
                throw new Error("");
        }
    };

    const getAnswers = ({ answers, state }) => {
        const result = Object.keys(answers).map(answer => {
            const questionSet = questions
                .map(q => {
                    return q.questions.filter(question => {
                        if (question.questionId === answer) {
                            return question;
                        }
                    });
                })
                .reduce((acc, curr) => acc.concat(curr), [])[0];

            const answeredQuestions = questionSet.input.options.map(opt => {
                if (opt.value === answers[answer] && opt.state === state) {
                    return {
                        id: answer,
                        question: questionSet.question,
                        answer: opt.text,
                        reason: opt.reason
                    };
                }
            });

            const filtered = answeredQuestions.filter(aq => {
                return aq !== undefined;
            });

            return filtered[0];
        });

        for (let key in result) {
            if (result[key] === undefined) {
                delete result[key];
            }
        }

        const myResult = [];

        Object.keys(result).map(r => {
            Log.info(result[r]);
            myResult.push(result[r]);
        });

        Log.info(myResult);

        return myResult;
    };

    if (results === undefined) {
        return null;
    }
    return <ScoreCard results={results} header={header} />;
};

export default ResultsContainer;
